import React, { useState } from "react";
import Phone from "../../assets/Phone.png";
import FeaturedCards from "../FeaturedCards/FeaturedCards";
import NewsSection from "./NewsSection";
import useStyles from "./styles";

import cakecoin from "../../assets/cakecoin.png";
import bnbcoin from "../../assets/bnbcoin.png";
import busd from "../../assets/busd.png";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { PostsAPI } from "../../lib/API";


const Home = ({ fetchCart, handleAddCart }) => {
  const classes = useStyles();

  const [posts, setPosts] = useState()

  useEffect(() => {
    PostsAPI.GetPosts(1, 4)
      .then(({ data }) => setPosts(data.items))
  }, [])

  return (
    <>
      <div className="home-banner">
        <div className="banner-bg">
          <img src={Phone} alt="phone" />
        </div>
        <div className="banner-text">
          <h1 className="title">
            The simplest way to buy <em>gift cards</em> online
          </h1>
          <p className="subtitle">
            Gift swap makes it easy for you to give the perfect gift card and
            conveniently manage them from any device.
          </p>
        </div>
        <Link to="/products" className="banner-btn p-0"><button className="btn-black btn-xl">Shop now</button></Link>
      </div>

      <FeaturedCards fetchCart={fetchCart} handleAddCart={handleAddCart} />

      <div className="gift-cards">
        <div className={classes.layer}>
          <div className="col-lg-4 col-md-8 col-sm-12">
            <div className="section-text">
              <div className="section-head float-left">
                <h3 className="section-title ">
                  Gift them what they really want!
                </h3>
                <p>Gift them what they really want! </p>
              </div>
              <p>
                With the gift swap Choice Card you can give the Choice of Hundreds
                of Gift Cards.{" "}
              </p>
            </div>
            <button className="btn-black mt-3 mt-md-5">Shop now</button>
          </div>
        </div>
      </div>

      {posts && posts.length > 0 && <NewsSection posts={posts}/>}

      <div className="tokens-section">
        <div className="section-head ">
          <h3 className="section-title mb-5">Buy Gift Cards with Tokens</h3>
          <p>buy your product quickly and easily</p>
        </div>

        <div className="section-body mb-3">
          <div className="token-list  ">
            <div className="token-item">
              <img src={bnbcoin} alt="bnb" />
              <h6 className="title">BNB</h6>
            </div>
            <div className="token-item">
              <img src={busd} alt="busd" />
              <h6 className="title">BUSD</h6>
            </div>
            <div className="token-item">
              <img src={cakecoin} alt="cake" />
              <h6 className="title">CAKE</h6>
            </div>
            {/* <div className="token-item">
              <img src={gifttoken} alt="gifttoken" />
              <h6 className="title">GIFT</h6>
            </div> */}
          </div>
        </div>
      </div>

      <section>



      </section>
      {/* <Footer /> */}
    </>
  );
};

export default Home;
